import React, { forwardRef } from 'react';
import { useMergeRefs } from '@floating-ui/react';

import { useTooltipContext } from './useTooltipContext';

export const WpTooltipTrigger = forwardRef<HTMLElement, React.HTMLProps<HTMLElement>>(function WpTooltipTrigger(
  { children, ...props },
  propRef
) {
  const context = useTooltipContext();
  const childrenRef = (children as any).ref;
  const ref = useMergeRefs([context.refs.setReference, propRef, childrenRef]);

  if (React.isValidElement(children)) {
    return React.cloneElement(
      children,
      context.getReferenceProps({
        ref,
        ...props,
        ...children.props,
        'data-state': context.open ? 'open' : 'closed',
      })
    );
  }
  return null;
});

export default WpTooltipTrigger;
